define('tdaUtils',[], function () {
  return {
    // THIS IS ONLY USED IN SOME RE-IMPLEMENTATIONS OF tcom items.
    // (see prius prime, vehicle-benefits), these region names may not apply to BAT itself.
    getRegion: function (state) {
      var mapping = {
        "AL": 'gulf-coast',
        'AK': 'west-coast-less-california',
        'AZ': 'west-coast-less-california',
        'AR': 'gulf-coast',
        'CA': 'california',
        'CO': 'rocky-mountain',
        'CT': 'new-england',
        'DE': 'central-atlantic',
        'DC': 'central-atlantic',
        'FL': 'lower-atlantic',
        'GA': 'lower-atlantic',
        'HI': 'west-coast-less-california',
        'ID': 'rocky-mountain',
        'IL': 'midwest',
        'IN': 'midwest',
        'IA': 'midwest',
        'KS': 'midwest',
        'KY': 'midwest',
        'LA': 'gulf-coast',
        'ME': 'new-england',
        'MD': 'central-atlantic',
        'MA': 'new-england',
        'MI': 'midwest',
        'MN': 'midwest',
        'MS': 'gulf-coast',
        'MO': 'midwest',
        'MT': 'rocky-mountain',
        'NE': 'midwest',
        'NV': 'west-coast-less-california',
        'NH': 'new-england',
        'NJ': 'central-atlantic',
        'NM': 'gulf-coast',
        'NY': 'central-atlantic',
        'NC': 'lower-atlantic',
        'ND': 'midwest',
        'OH': 'midwest',
        'OK': 'midwest',
        'OR': 'west-coast-less-california',
        'PA': 'central-atlantic',
        'PR': '',
        'RI': 'new-england',
        'SC': 'lower-atlantic',
        'SD': 'midwest',
        'TN': 'midwest',
        'TX': 'gulf-coast',
        'UT': 'rocky-mountain',
        'VT': 'new-england',
        'VI': '',
        'VA': 'lower-atlantic',
        'WA': 'west-coast-less-california',
        'WV': 'lower-atlantic',
        'WI': 'midwest',
        'WY': 'rocky-mountain'
      };

      return mapping[state];
    },

    // GET STATE ABBREVIATION FROM state string. shoud be passed in unescaped.
    getStateAbbr: function (value) {
      if (value !== 'all') { // CONVERT FIRST LETTER TO UPPER CASE.
        value = value.substr(0, 1).toUpperCase() + value.substr(1);
      }
      states_hash = {
        'Alabama': 'AL',
        'Alaska': 'AK',
        'American Samoa': 'AS',
        'Arizona': 'AZ',
        'Arkansas': 'AR',
        'California': 'CA',
        'Colorado': 'CO',
        'Connecticut': 'CT',
        'Delaware': 'DE',
        'District Of Columbia': 'DC',
        'Federated States Of Micronesia': 'FM',
        'Florida': 'FL',
        'Georgia': 'GA',
        'Guam': 'GU',
        'Hawaii': 'HI',
        'Idaho': 'ID',
        'Illinois': 'IL',
        'Indiana': 'IN',
        'Iowa': 'IA',
        'Kansas': 'KS',
        'Kentucky': 'KY',
        'Louisiana': 'LA',
        'Maine': 'ME',
        'Marshall Islands': 'MH',
        'Maryland': 'MD',
        'Massachusetts': 'MA',
        'Michigan': 'MI',
        'Minnesota': 'MN',
        'Mississippi': 'MS',
        'Missouri': 'MO',
        'Montana': 'MT',
        'Nebraska': 'NE',
        'Nevada': 'NV',
        'New Hampshire': 'NH',
        'New Jersey': 'NJ',
        'New Mexico': 'NM',
        'New York': 'NY',
        'North Carolina': 'NC',
        'North Dakota': 'ND',
        'Northern Mariana Islands': 'MP',
        'Ohio': 'OH',
        'Oklahoma': 'OK',
        'Oregon': 'OR',
        'Palau': 'PW',
        'Pennsylvania': 'PA',
        'Puerto Rico': 'PR',
        'Rhode Island': 'RI',
        'South Carolina': 'SC',
        'South Dakota': 'SD',
        'Tennessee': 'TN',
        'Texas': 'TX',
        'Utah': 'UT',
        'Vermont': 'VT',
        'Virgin Islands': 'VI',
        'Virginia': 'VA',
        'Washington': 'WA',
        'West Virginia': 'WV',
        'Wisconsin': 'WI',
        'Wyoming': 'WY'
      };

      var rv = states_hash[value] ? states_hash[value] : '';
      if (value === 'all') {
        rv = states_hash;
      }
      return rv;
    },

    // allows a retreive a full list of states.
    getAllStates: function () {
      return this.getStateAbbr('all');
    }
  };
});

